import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';

/**
 * Duration for the transition
 */
const duration = 300;

/**
 * Default Style for Backlayer
 */
const defaultBackLayerStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

/**
 * Trasition Styles for Backlayer
 */
const backLayerTransitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 0.4 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

/**
 * Default Style for ModalContent
 */
const defaultModalContentStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
};

/**
 * Trasition Styles for ModalContent
 */
const transitionModalContentStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

class Modal extends Component {
  constructor(props) {
    super(props);

    this.disableBodyScroll = this.disableBodyScroll.bind(this);
    this.enableBodyScroll = this.enableBodyScroll.bind(this);
  }

  componentWillUnmount() {
    document.querySelector('body').style.overflow = 'auto';
  }

  /**
   * Disable the body scroll when Opened
   */
  disableBodyScroll() {
    document.querySelector('body').style.overflow = 'hidden';

    // Start Function if recieved a onEntering Props
    const { onEntering } = this.props;
    if (onEntering) onEntering();
  }

  /**
   * Enable the body scroll when Closed
   */
  enableBodyScroll() {
    document.querySelector('body').style.overflow = 'auto';

    // Start Function if recieved a onExiting Props
    const { onExiting } = this.props;
    if (onExiting) onExiting();
  }

  render() {
    const { children, isOpen, onClose, align, ...rest } = this.props;

    return (
      <Transition
        in={isOpen}
        timeout={duration}
        onEntering={this.disableBodyScroll}
        onExiting={this.enableBodyScroll}
        unmountOnExit
      >
        {(state) => (
          <>
            <Div
              style={{
                ...defaultBackLayerStyle,
                ...backLayerTransitionStyles[state],
              }}
              pos="fixed"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bg="black"
              opacity="0.4"
              zIndex="1000"
            />
            <Div
              style={{
                ...defaultModalContentStyle,
                ...transitionModalContentStyles[state],
              }}
              onClick={onClose}
              pos="fixed"
              top="0"
              left="0"
              right="0"
              h="100vh"
              d="flex"
              align={align}
              justify="center"
              zIndex="1001"
              cursor="pointer"
            >
              <Div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                bg="white"
                {...rest}
                zIndex="1"
              >
                {children}
              </Div>
            </Div>
          </>
        )}
      </Transition>
    );
  }
}

/* eslint-disable react/require-default-props */

Modal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  align: PropTypesRepo.align,
};

/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Modal.defaultProps = {
  m: { y: { xs: '16px', lg: '32px' }, x: { xs: '16px', lg: 'auto' } },
  p: '32px',
  maxW: '512px',
  w: '100%',
  pos: 'relative',
  shadow: '4',
  cursor: 'default',
  align: 'start',
  onClose: () => {},
  onEntering: null,
  onExiting: null,
  isOpen: false,
};

/* eslint-enable react/default-props-match-prop-types */

export default Modal;
